import Vue from 'vue'
import Vuex from 'vuex'
import * as fb from '../firebase'
import router from '../router/index'

Vue.use(Vuex)

// realtime firebase
/*fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
  let postsArray = []

  snapshot.forEach(doc => {
    let post = doc.data()
    post.id = doc.id

    postsArray.push(post)
  })

  store.commit('setPosts', postsArray)
})*/

fb.oldModulesRef.on("value", function (snapshot) {
  var modulesByUE = snapshot.val()
  var modules = {}

  for (var ue in modulesByUE) {
    for (var moduleName in modulesByUE[ue]["list"]) {
      modules[moduleName] = modulesByUE[ue]["list"][moduleName]
    }
  }

  store.commit('setOldModulesByUE', modulesByUE)
  store.commit('setOldModules', modules)
});

fb.modulesRef.on("value", function (snapshot) {
  var modules = snapshot.val()
  var modulesByUE = {}
  var modulesByAlias = {}

  for (var moduleId of Object.keys(modules)) {
    var module = modules[moduleId]
    module['id'] = moduleId
    if (module.ue != "") {
      if (modulesByUE[module.ue] === undefined) modulesByUE[module.ue] = []
      modulesByUE[module.ue].push(module)
    }

    if (module.alias !== undefined) {
      for (var alias of modules[moduleId].alias) {
        modulesByAlias[alias] = moduleId
      }

      if (module.displayId != "") {
        modulesByAlias[module.displayId + " - " + module.displayName] = moduleId
        if (module.shortName != "") {
          modulesByAlias[module.displayId + " - " + module.shortName] = moduleId
        }
      }
    }
  }

  for (var ueId of Object.keys(modulesByUE)) {
    modulesByUE[ueId].sort(function (a, b) {
      return a.displayId > b.displayId;
    });
  }

  store.commit('setModules', modules)
  store.commit('setModulesByUE', modulesByUE)
  store.commit('setModulesByAlias', modulesByAlias)
});

const store = new Vuex.Store({
  state: {
    userProfile: {},
    modules: {},
    modulesByUE: {},
    modulesByAlias: {},
    oldModules: {},
    oldModulesByUE: {},
    posts: [],
    agendaRef: null,
    planningRef: null,
    config: {
      semester: 1
    }
  },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setPerformingRequest(state, val) {
      state.performingRequest = val;
    },
    setPosts(state, val) {
      state.posts = val;
    },
    setOldModules(state, val) {
      state.oldModules = val;
    },
    setOldModulesByUE(state, val) {
      state.oldModulesByUE = val;
    },
    setModules(state, val) {
      state.modules = val;
    },
    setModulesByUE(state, val) {
      state.modulesByUE = val;
    },
    setModulesByAlias(state, val) {
      state.modulesByAlias = val;
    },
    setAgendaRef(state, val) {
      state.agendaRef = val;
    },
    setPlanningRef(state, val) {
      state.planningRef = val;
    }
  },
  actions: {
    async login({
      dispatch
    }, form) {
      // sign user in
      const {
        user
      } = await fb.auth.signInWithEmailAndPassword(form.email, form.password)

      // fetch user profile and set in state
      dispatch('fetchUserProfile', user);
    },
    async loginWithCustomToken({
      dispatch
    }, token) {
      const {
        user
      } = await fb.auth.signInWithCustomToken(token)
      dispatch('fetchUserProfile', user);
    },
    /*async signup({ dispatch }, form) {
      // sign user up
      const { user } = await fb.auth.createUserWithEmailAndPassword(form.email, form.password)

      // create user object in userCollections
      await fb.usersCollection.doc(user.uid).set({
        name: form.name,
        title: form.title
      })

      // fetch user profile and set in state
      dispatch('fetchUserProfile', user)
    },*/
    async fetchUserProfile({
      commit
    }, user) {
      fb.auth.currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          if (new Date(idTokenResult.authTime) < new Date("2021-02-01 04:12:00")) {
            // Token périmé depuis la dernière grosse mise à jour
            store.dispatch('logout')
            return
          }
          var userProfile = {
            "uid": user.uid,
            "displayName": user.displayName,
            "photoURL": user.photoURL,
            "email": user.email,
            "group1": idTokenResult.claims.group1,
            "subgroup1": idTokenResult.claims.subgroup1,
            "group2": idTokenResult.claims.group2,
            "subgroup2": idTokenResult.claims.subgroup2,
            "permissions": idTokenResult.claims.permissions,
            "options": idTokenResult.claims.options,
            "roles": idTokenResult.claims.roles,
          }

          // set user profile in state
          commit('setUserProfile', userProfile)

          var semester = 1;
          var agendaRef = fb.rtdb.ref("agenda/" + userProfile["group" + semester]);
          var planningRef = fb.rtdb.ref("planning");
          store.commit('setAgendaRef', agendaRef);
          store.commit('setPlanningRef', planningRef);

          // change route to dashboard
          if (router.currentRoute.path === '/login' || router.currentRoute.path === '/gitlab' || router.currentRoute.path === '/u-bordeaux.fr') {
            router.push('/dashboard')
          }
        })
        .catch((error) => {
          console.log(error);
        });


      /* // fetch user profile
       var info = fb.functions.httpsCallable('info');
       info({ text: "Hello World" }).then(function (result) {
         var userProfile = result["data"];
         var semester = 1;
         var agendaRef = fb.rtdb.ref("agenda/" + userProfile["group" + semester]);
         var planningRef = fb.rtdb.ref( "planning/" + userProfile["group" + semester] + (userProfile["subgroup" + semester] == "prime" ? "'" : "''"));
         store.commit('setAgendaRef', agendaRef);
         store.commit('setPlanningRef', planningRef);
         // set user profile in state
         commit('setUserProfile', userProfile)
         // change route to dashboard
         if (router.currentRoute.path === '/login' || router.currentRoute.path === '/gitlab' || router.currentRoute.path === '/u-bordeaux.fr') {
           router.push('/dashboard')
         }
       });*/
    },
    async logout({
      commit
    }) {
      // log user out
      await fb.auth.signOut()

      // clear user data from state
      commit('setUserProfile', {})

      // redirect to login view
      router.push('/login')
    },
    /*async createPost({ state, commit }, post) {
      // create post in firebase
      await fb.postsCollection.add({
        createdOn: new Date(),
        content: post.content,
        userId: fb.auth.currentUser.uid,
        userName: state.userProfile.name,
        comments: 0,
        likes: 0
      })
    },
    async likePost ({ commit }, post) {
      const userId = fb.auth.currentUser.uid
      const docId = `${userId}_${post.id}`

      // check if user has liked post
      const doc = await fb.likesCollection.doc(docId).get()
      if (doc.exists) { return }

      // create post
      await fb.likesCollection.doc(docId).set({
        postId: post.id,
        userId: userId
      })

      // update post likes count
      fb.postsCollection.doc(post.id).update({
        likes: post.likesCount + 1
      })
    },
    async updateProfile({ dispatch }, user) {
      const userId = fb.auth.currentUser.uid
      // update user object
      const userRef = await fb.usersCollection.doc(userId).update({
        name: user.name,
        title: user.title
      })

      dispatch('fetchUserProfile', { uid: userId })

      // update all posts by user
      const postDocs = await fb.postsCollection.where('userId', '==', userId).get()
      postDocs.forEach(doc => {
        fb.postsCollection.doc(doc.id).update({
          userName: user.name
        })
      })

      // update all comments by user
      const commentDocs = await fb.commentsCollection.where('userId', '==', userId).get()
      commentDocs.forEach(doc => {
        fb.commentsCollection.doc(doc.id).update({
          userName: user.name
        })
      })
    }*/
  }
})

export default store